import { Component, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ContactDialogComponent } from '../contact-dialog/contact-dialog.component';

@Component({
    selector: 'app-contact-card',
    templateUrl: './contact-card.component.html',
    styleUrls: ['./contact-card.component.css'],
    standalone: false
})
export class ContactCardComponent {
  @Input() icon: string = '';
  @Input() name: string = '';
  @Input() email: string = '';

  constructor(public dialog: MatDialog) { }

  openDialog() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      email: this.email
    }

    this.dialog.open(ContactDialogComponent, dialogConfig);
  }

}
